
import gql from 'graphql-tag'
import userFavProductAnnuity from '@/apollo/queries/user/userFavProductAnnuity'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import annuityTooltips from '~/apollo/queries/product/tooltips/annuityTooltips'
import immediateAnnuityTooltips from '~/apollo/queries/product/tooltips/immediateAnnuityTooltips'
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import FilterSelection from '~/components/products/filter-components/FilterSelection.vue'
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import ComparisonMobileContentSection from '~/components/products/comparison/Content/ComparisonMobileContentSection.vue'


export default {
  name: "FavProductAnnuity",
  mixins: [productPromotionMixins, productInsuranceNameMixins,  productShortcutMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    params: String,
    favProductId: String,
  },
  apollo: {
    product: {
      prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductAnnuity} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        // console.debug('query vars:');
        // console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        return data?.annuityPlanScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
      },
    },
    annuityTooltips: {
      query: annuityTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).Annuity;
      },
    },
    immediateAnnuityTooltips: {
      query: immediateAnnuityTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).ImmediateAnnuity;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;

            const planName =
            item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;

            let decoderCTALink = '';
            let mainCTA = this.getDecoderCTA(item, decoderCTALink);

            // check scenario level promo first , then plan level promotion
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.annuity_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.annuity_plan.data.attributes.product_promotions.data;
            }

            if (promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink =
                  promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;

                mainCTA = this.getDecoderCTA(item, decoderCTALink);
              }
            }
            const getFulfilmentShortcut = this.getAnnuityFulfilmentShortcut(item.attributes);
            const shortcutfilfulmentRatio = getFulfilmentShortcut.fulfilmentRatio;

            const filteredTranslations = this.getFilteredTranslations(item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .insurance_company_translations.data[0].attributes.localizations.data);


            const savings_result = item.attributes.annuity_plan_financial_details.data.filter(
              (item) => item.attributes.age === 60
            );


            const stable_retirement_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                if (this.simpleParams?.age) { 
                  return fd.attributes.age === parseFloat(this.simpleParams?.age);
                };
                if (item.attributes.income_term_end > 85) {
                  return fd.attributes.age === 85;
                };
                return fd.attributes.age === item.attributes.income_term_end;
              }
            )

            const growth_retirement_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                if (this.simpleParams?.age) {
                  return fd.attributes.age === parseFloat(this.simpleParams?.age);
                };
                if (item.attributes.income_term_end > 85) {
                  return fd.attributes.age === 85;
                };
                return fd.attributes.age === item.attributes.income_term_end;
              }
            )
            const longevity_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                if (item.attributes.income_term_end < 105 && item.attributes.income_term_end !== -1) {
                  return fd.attributes.age === item.attributes.income_term_end;
                }
                return fd.attributes.age === 105;
              }
            )
            const longevity_100_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                return fd.attributes.age === 100;
              }
            );

            const immediate_annuity_result = item.attributes.annuity_plan_financial_details.data.filter(
              (fd) => {
                if (item.attributes.income_term_end < 105 && item.attributes.income_term_end !== -1) {
                  return fd.attributes.age === item.attributes.income_term_end;
                }
                return fd.attributes.age === 105;
              }
            )
            const immediate_annuity_result_85 = item.attributes.annuity_plan_financial_details.data.filter(
            (fd) => fd.attributes.age === 85
          )

            // if (item.attributes.type === 'deferred annuity')
              return {
                type: item.attributes.type,
                plan_code: item.attributes.annuity_plan.data.attributes.plan_code,
                scenario_code: item.attributes.scenario_code,
                premium_term: item.attributes.premium_term,
                income_term_start: item.attributes.income_term_start,
                income_term: item.attributes.income_term,
                income_term_end: item.attributes.income_term_end,
                gbey: item.attributes.gbey,
                currency_code: item.attributes.currency.data.attributes.code,
                shortcutfilfulmentRatio,

                // // plan
                plan_name: planName,
                // // insurer
                insurer_name_first:
                  item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                    .insurance_company_translations.data[0].attributes.name,
                insurer_name_second:
                  filteredTranslations[0].attributes.name,
                insurer_logo:
                  item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                    .logo,
                insurer_code:
                  item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                    .code,
                insurer_ifs: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_ifs.data.attributes,
                insurer_fr_details: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_ifs.data.attributes,

                // // financial details
                savings_result,
                stable_retirement_result,
                longevity_result,
                longevity_100_result,
                growth_retirement_result,
                immediate_annuity_result,
                immediate_annuity_result_85,
                first_income_result: item.attributes.annuity_plan_financial_details.data.filter(
                  (e) => e.attributes.age === item.attributes.income_term_start
                ),
                product_promotion: promotion,
                promotion_last_call: promotion_last_call,

                scenarioID: item.id,

                main_cta: mainCTA,

                overall_star_savings: savings_result[0]?.attributes?.overall_star_savings,
                overall_star_stable_retirement: stable_retirement_result[0]?.attributes?.overall_star_stable_retirement,
                overall_star_growth_retirement: growth_retirement_result[0]?.attributes?.overall_star_growth_retirement,
                overall_star_longevity: longevity_result[0]?.attributes?.overall_star_longevity,
                overall_star_immediate: immediate_annuity_result[0]?.attributes?.overall_star_immediate,

                // Convert in to function
                g_initial_annual_income_savings: (savings_result[0]?.attributes?.initial_income_gcv / savings_result[0]?.attributes?.discounted_tpp) * item?.attributes.tpp_display,
                g_initial_annual_income_stable_retirement: (stable_retirement_result[0]?.attributes?.initial_income_gcv / stable_retirement_result[0]?.attributes?.discounted_tpp) * item?.attributes.tpp_display,
                g_initial_annual_income_growth_retirement: (growth_retirement_result[0]?.attributes?.initial_income_gcv / growth_retirement_result[0]?.attributes?.discounted_tpp) * item?.attributes.tpp_display,
                g_initial_annual_income_longevity: (longevity_result[0]?.attributes?.initial_income_gcv / longevity_result[0]?.attributes?.discounted_tpp) * item?.attributes.tpp_display,
                g_initial_annual_income_immediate_annuity: (immediate_annuity_result[0]?.attributes?.initial_income_gcv / item?.attributes.total_premium)*item?.attributes.tpp_display ,
                p_initial_annual_income_immediate_annuity: (immediate_annuity_result[0]?.attributes?.initial_income_tot / item?.attributes.total_premium)*item?.attributes.tpp_display ,
              };
            // else
            //   return {
            //     type: item.attributes.type,
            //     plan_code: item.attributes.annuity_plan.data.attributes.plan_code,
            //     scenario_code: item.attributes.scenario_code,
            //     g_income_yearone: item.attributes.g_income_yearone,
            //     p_income_yearone_base: item.attributes.p_income_yearone_base,
            //     premium_term: item.attributes.premium_term,
            //     income_term_start: item.attributes.income_term_start,
            //     income_term: item.attributes.income_term,
            //     overall_star_longevity: item.attributes.overall_star_longevity,
            //     gbey: item.attributes.gbey,
            //     currency_code: item.attributes.currency.data.attributes.code,

            //     annuity_longevity_score: item.attributes.annuity_longevity_score,

            //     // // plan
            //     plan_name: item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name,

            //     // // insurer
            //     insurer_name_first: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name,
            //     insurer_name_second: filteredTranslations[0].attributes.name,
            //     insurer_logo: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo,
            //     insurer_code: item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,

            //     // financial details
            //     longevity_result: item.attributes.annuity_plan_financial_details.data.filter(item => item.attributes.age === 85),

            //     product_promotion: promotion,
            //     promotion_last_call: promotion_last_call,

            //     main_cta: mainCTA,
            //     scenarioId: item.id,
            //   };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      if (this.simpleItem) {
        // if (this.simpleItem.type === 'deferred annuity') {
          let mConditionalResult = {};

          if (this.simpleParams.objective === 'savings') {
              mConditionalResult = {
              showFiveStarBadge: this.simpleItem.overall_star_savings,
              keyItems: [
                {
                  value: this.$formatPrice(this.simpleItem.g_initial_annual_income_savings),
                  key: this.$t('products.annuity.as_guaranteedInitialAnnualIncome'),
                  topSubText: this.simpleItem.currency_code,
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: ''
                },
                {
                  value: this.$formatPercentage(this.simpleItem.savings_result[0]?.attributes.g_return_ratio),
                  key: this.$t('products.annuity.as_guaranteedReturnRatioatAge60'),
                  topSubText: '',
                  toolTipHtml: this.getAnnuityTooltipContentByKey('tl_guaranteedReturnRatioatAge60'),
                  symbolValue: '',
                  originalValue: ''
                },
                {
                  value: this.$formatPercentage(this.simpleItem.savings_result[0]?.attributes?.p_return_ratio),
                  key: this.$t('products.annuity.as_projectedReturnRatioatAge60'),
                  topSubText: '',
                  toolTipHtml: this.getAnnuityTooltipContentByKey('tl_projectedReturnRatioatAge60'),
                  symbolValue: '',
                  originalValue: ''
                },
                {
                  value: this.simpleItem.savings_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: ''
                }
              ],
              compactKeyItems: [
                {
                  value: this.$formatPercentage(this.simpleItem.savings_result[0]?.attributes.g_return_ratio),
                  key: this.$t('products.annuity.as_guaranteedReturnRatioatAge60'),
                  topSubText: '',
                  toolTipHtml: this.getAnnuityTooltipContentByKey('tl_guaranteedReturnRatioatAge60'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.simpleItem.savings_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.as_guaranteedBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: false,
                }
              ]
            };
          } else if (this.simpleParams.objective === 'stable_retirement_income') {
              mConditionalResult = {
              showFiveStarBadge: this.simpleItem.overall_star_stable_retirement,
              keyItems: [
                {
                  value: this.$formatPrice(this.simpleItem?.g_initial_annual_income_stable_retirement),
                  key: this.$t('products.annuity.ar_guaranteedInitialAnnualIncome'),
                  topSubText: this.simpleItem.currency_code,
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: ''
                },
                {
                  value: this.$formatPercentageDP(this.simpleItem.stable_retirement_result[0]?.attributes.g_return_ratio, 1),
                  key:  this.simpleItem.income_term_end > 85 ? this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', 85) :  this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', this.simpleItem.income_term_end),
                  topSubText: '',
                  toolTipHtml: this.simpleItem.income_term_end === 75 ? this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.$formatPercentageDP(this.simpleItem.stable_retirement_result[0]?.attributes?.p_return_ratio, 1),
                  key: this.simpleItem.income_term_end > 85 ? this.$t('products.annuity.ar_projectedReturnRatioatAge').replace('$num', 85) : this.$t('products.annuity.ar_projectedReturnRatioatAge').replace('$num', this.simpleItem.income_term_end),
                  topSubText: '',
                  toolTipHtml: this.simpleItem.income_term_end === 75 ? this.getAnnuityTooltipContentByKey('ar_projectedReturnRatioatAge75') : this.getAnnuityTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.simpleItem.stable_retirement_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                }
              ],
              compactKeyItems: [
                {
                  value: this.$formatPercentageDP(this.simpleItem.stable_retirement_result[0]?.attributes.g_return_ratio, 1),
                  key: this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', this.simpleParams?.age),
                  topSubText: '',
                  toolTipHtml: this.simpleParams?.age === '75' ? this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.simpleItem.stable_retirement_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                }
              ]
            };
          } else if (this.simpleParams.objective === 'growth_retirement_income') {
            mConditionalResult = {
            showFiveStarBadge: this.simpleItem.overall_star_growth_retirement,
            keyItems: [
                {
                  value: this.$formatPrice(this.simpleItem?.g_initial_annual_income_growth_retirement),
                  key: this.$t('products.annuity.ar_guaranteedInitialAnnualIncome'),
                  topSubText: this.simpleItem.currency_code,
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: ''
                },
                {
                  value: this.$formatPercentageDP(this.simpleItem.growth_retirement_result[0]?.attributes.g_return_ratio, 1),
                  key:  this.simpleItem.income_term_end > 85 ? this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', 85) : this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', this.simpleItem.income_term_end),
                  topSubText: '',
                  toolTipHtml: this.simpleItem.income_term_end === 75 ? this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.$formatPercentageDP(this.simpleItem.growth_retirement_result[0]?.attributes?.p_return_ratio, 1),
                  key: this.simpleItem.income_term_end > 85 ? this.$t('products.annuity.ar_projectedReturnRatioatAge').replace('$num', 85) : this.$t('products.annuity.ar_projectedReturnRatioatAge').replace('$num', this.simpleItem.income_term_end),
                  topSubText: '',
                  toolTipHtml: this.simpleItem.income_term_end === 75 ? this.getAnnuityTooltipContentByKey('ar_projectedReturnRatioatAge75') : this.getAnnuityTooltipContentByKey('ar_projectedReturnRatioatAge85'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.simpleItem.growth_retirement_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                }
              ],
            compactKeyItems: [
              {
                value: this.$formatPercentageDP(this.simpleItem.growth_retirement_result[0]?.attributes.g_return_ratio, 1),
                key: this.$t('products.annuity.ar_guaranteedReturnRatioatAge').replace('$num', this.simpleParams?.age),
                topSubText: '',
                toolTipHtml: this.simpleParams?.age === '75' ? this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge75') : this.getAnnuityTooltipContentByKey('ar_guaranteedReturnRatioatAge85'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.simpleItem.growth_retirement_result[0]?.attributes.gbey,
                key: this.$t('products.annuity.ar_guranteedBreakevenYear'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              }
            ]
          };
          } else if (this.simpleParams.objective === 'longevity') {
              mConditionalResult = {
              showFiveStarBadge: this.simpleItem.overall_star_longevity,
              keyItems: [
                {
                  value: this.$formatPrice(this.simpleItem?.g_initial_annual_income_longevity),
                  key: this.$t('products.annuity.al_guaranteedInitialAnnualIncome'),
                  topSubText: this.simpleItem.currency_code,
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: false,
                },
                {
                  value: this.$formatPercentageDP(this.simpleItem.longevity_100_result[0]?.attributes.g_return_ratio, 1),
                  key: this.$t('products.annuity.al_guaranteedReturnRatioatAge100'),
                  topSubText: '',
                  toolTipHtml: this.getAnnuityTooltipContentByKey('al_guaranteedReturnRatioatAge100'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.$formatPercentageDP(this.simpleItem.longevity_100_result[0]?.attributes?.p_return_ratio, 1),
                  key: this.$t('products.annuity.al_projectedReturnRatioatAge100'),
                  topSubText: '',
                  toolTipHtml: this.getAnnuityTooltipContentByKey('al_projectedReturnRatioatAge100'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.simpleItem.longevity_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: false,
                }
              ],
              compactKeyItems: [
                {
                  value: this.$formatPercentageDP(this.simpleItem.longevity_100_result[0]?.attributes.g_return_ratio, 1),
                  key: this.$t('products.annuity.al_guaranteedReturnRatioatAge100'),
                  topSubText: '',
                  toolTipHtml: this.getAnnuityTooltipContentByKey('al_guaranteedReturnRatioatAge100'),
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: true,
                },
                {
                  value: this.simpleItem.longevity_result[0]?.attributes.gbey,
                  key: this.$t('products.annuity.al_guaranteedAnnuityBreakevenYear'),
                  topSubText: '',
                  toolTipHtml: '',
                  symbolValue: '',
                  originalValue: '',
                  isTextBlack: false,
                }
              ]
            };            
          } else if (this.simpleParams.objective === 'immediate_annuity') {
            mConditionalResult = {
            showFiveStarBadge: this.simpleItem.overall_star_immediate,
            keyItems: [
              {
                value: this.$formatPercentageDP(this.simpleItem?.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr, 1),
                key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
                topSubText: '',
                toolTipHtml: this.getImmediateAnnuityTooltipContentByKey('ai_guaranteedAnnuityInternalRateofReturnIRR'),
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
              {
                value: this.$formatPrice(this.simpleItem.g_initial_annual_income_immediate_annuity),
                key: this.$t('products.annuity.ai_guaranteedInitialAnnualIncome'),
                topSubText: this.simpleItem.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              },
              {
                value: this.$formatPrice(this.simpleItem.p_initial_annual_income_immediate_annuity),
                key: this.$t('products.annuity.ai_projectedInitialAnnualIncome'),
                topSubText: this.simpleItem.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
              },
            ],
            compactKeyItems: [
              {
                value: this.$formatPrice(this.simpleItem.g_initial_annual_income_immediate_annuity),
                key: this.$t('products.annuity.ai_guaranteedInitialAnnualIncome'),
                topSubText: this.simpleItem.currency_code,
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: false,
                isTextBold: true,
              },
              {
                value: this.$formatPercentageDP(this.simpleItem?.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr, 1),
                key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
                topSubText: '',
                toolTipHtml: '',
                symbolValue: '',
                originalValue: '',
                isTextBlack: true,
              },
            ],
          };
          }
          else {
            return null;
          }

          return {
            favProductId: this.favProductId,
            scenarioId: this.simpleItem.scenarioId,
            id: this.simpleItem.scenario_code,
            productType: "annuity",
            showFiveStarBadge: mConditionalResult.showFiveStarBadge,
            showTrending: false,
            productLink: this.simpleParams.objective === 'immediate_annuity' ? this.$extendPath('/products/immediate-annuity', this.simpleItem.scenario_code) : this.$extendPath('/products/deferred-annuity', this.simpleParams.objective + '/' + this.simpleItem.scenario_code),
            productName: this.simpleItem.plan_name,
            insuranceCompany: {
              name: this.simpleItem.insurer_name_first + ' | ' + this.simpleItem.insurer_name_second,
              code: this.simpleItem.insurer_code,
              logoSrc: this.simpleItem.insurer_logo?.data?.attributes.url,
              logoAlt: this.simpleItem.insurer_name_en,
            },
            userRating: {
              score: this.getScore(this.simpleItem),
              numberOfRatedUser: '0',
            },
            tenlifeScore: {
              score: parseFloat(this.getScore(this.simpleItem)),
              description: this.getScoreLabel(),
              toolTipHtml: this.getScoreTooltip(),
            },
            features: [
              {
                text: 
                this.simpleItem.premium_term === 1 ? this.$t('products.annuity.ai_singlePremium') : this.simpleItem.premium_term + this.$t('products.yearPremium'),
                type: 'payment_term',
              },
              {
                text: this.$formatAge(this.$normalizeLocale(this.$i18n.locale), this.simpleItem.income_term_start, this.$t('products.ageUnit')) + this.$t('products.annuity.as_annuityStart'),
                type: 'annuity_start_age',
              },
              {
                text: 
                this.simpleItem.income_term === 999 ? this.$t('products.annuity.ai_wholelife') : this.simpleItem.income_term + this.$t('products.yearAnnuity'),
                type: 'income_term',
              }
            ],
            keyItems: mConditionalResult.keyItems,
            compactKeyItems: mConditionalResult.compactKeyItems,
            promotion: {
              category: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
              title: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
              ctaButtonLink: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
              ctaButtonText: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
              promotionId: this.simpleItem.product_promotion?.id,
              scenarioId: this.simpleItem.scenarioId,
              lastCall: this.simpleItem.promotion_last_call

            },
            mainButtonCTA: this.simpleItem.main_cta,
          }
        }
        // else {
        //   return {
        //     favProductId: this.favProductId,
        //     scenarioId: this.simpleItem.scenarioId,
        //     productType: "annuity",
        //     showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItem.overall_star_longevity),
        //     showTrending: false,

        //     productLink: this.$extendPath(this.$route.path.replace('/my-favourite', '/products/immediate-annuity'), '/' + this.simpleItem.scenario_code),
        //     productName: this.simpleItem.plan_name,
        //     insuranceCompany: {
        //       name: this.simpleItem.insurer_name_first + ' | ' + this.simpleItem.insurer_name_second,
        //       code: this.simpleItem.insurer_code,
        //       logoSrc: this.simpleItem.insurer_logo?.data?.attributes.url,
        //       logoAlt: this.simpleItem.insurer_name_first,
        //     },
        //     userRating: {
        //       score: this.$formatScore(this.simpleItem.annuity_longevity_score),
        //       numberOfRatedUser: '0',
        //     },
        //     tenlifeScore: {
        //       score: parseFloat(this.simpleItem.annuity_longevity_score),
        //       description: this.$t('products.annuity.ai_immediateAnnuityScore'),
        //       toolTipHtml: this.getImmediateAnnuityTooltipContentByKey('ai_immediateAnnuityScore'),
        //     },
        //     features: [
        //       {
        //         text: this.simpleItem.premium_term === 1 ? this.$t('products.annuity.ai_singlePremium') : this.simpleItem.premium_term + this.$t('products.yearPremium'),
        //         type: 'default',
        //       },
        //       {
        //         text: this.$formatAge(this.$normalizeLocale(this.$i18n.locale), this.simpleItem.income_term_start, this.$t('products.ageUnit')) + this.$t('products.annuity.as_annuityStart'),

        //         type: 'default',
        //       },
        //       {
        //         text: this.simpleItem.income_term === 999 ? this.$t('products.annuity.ai_wholelife') : this.simpleItem.income_term + this.$t('products.yearAnnuity'),
        //         type: 'default',
        //       },
        //     ],
        //     keyItems: [
        //       {
        //         value: this.$formatPercentageDP(this.simpleItem.longevity_result[0].attributes.death_non_accum_girr, 1),
        //         key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
        //         topSubText: '',
        //         toolTipHtml: '',
        //         symbolValue: '',
        //         originalValue: '',
        //       },
        //       {
        //         value: this.$formatPrice(this.simpleItem.g_income_yearone),
        //         key: this.$t('products.annuity.ai_1stYearGuaranteedIncome'),
        //         topSubText: this.simpleItem.currency_code,
        //         toolTipHtml: '',
        //         symbolValue: '',
        //         originalValue: '',
        //       },
        //       {
        //         value: this.$formatPrice(this.simpleItem.p_income_yearone_base),
        //         key: this.$t('products.annuity.ai_1stYearExpectedIncome'),
        //         topSubText: this.simpleItem.currency_code,
        //         toolTipHtml: '',
        //         symbolValue: '',
        //         originalValue: '',
        //       },
        //     ],
        //     compactKeyItems: [
        //       {
        //         value: this.$formatPrice(this.simpleItem.g_income_yearone),
        //         key: this.$t('products.annuity.ai_1stYearGuaranteedIncome'),
        //         topSubText: this.simpleItem.currency_code,
        //         toolTipHtml: '',
        //         symbolValue: '',
        //         originalValue: '',
        //       },
        //       {
        //         value: this.$formatPercentageDP(this.simpleItem.longevity_result[0].attributes.death_non_accum_girr, 1),
        //         key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
        //         topSubText: '',
        //         toolTipHtml: '',
        //         symbolValue: '',
        //         originalValue: '',
        //       },
        //     ],
        //     promotion: {
        //       category: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
        //       title: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
        //       ctaButtonLink: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
        //       ctaButtonText: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
        //       promotionId: this.simpleItem.product_promotion?.id,
        //       scenarioId: this.simpleItem.scenarioId,
        //       lastCall: this.simpleItem.promotion_last_call
        //     },
        //     mainButtonCTA: this.simpleItem.main_cta,
        //     price: {
        //       originalPrice: '',
        //       discountPrice: '',
        //       prefix: '',
        //       postfix: '',
        //       subText: '',
        //       toolTipHtml: '',
        //     },
        //   }
        // }
      // }
      return null
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split("=");
        vars[params[0]] = params[1];
      }

      return vars;
    }
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'Annuity');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getScore(product) {
      if (this.simpleParams.objective === 'savings' && product.savings_result[0]) {
        return product.savings_result[0]?.attributes.savings_total_overall_score;
      }
      else if (this.simpleParams.objective === 'growth_retirement_income' && product.growth_retirement_result[0]) {
        return product.growth_retirement_result[0]?.attributes.growth_retirement_total_overall_score;
      }
      else if (this.simpleParams.objective === 'stable_retirement_income' && product.stable_retirement_result[0]) {
        return product.stable_retirement_result[0]?.attributes.stable_retirement_total_overall_score;
      }
      else if (this.simpleParams.objective === 'longevity' && product.longevity_result[0]) {
        return product.longevity_result[0]?.attributes.longevity_total_overall_score;
      }
      else if (this.simpleParams.objective === 'immediate_annuity' && product.immediate_annuity_result[0]) {
        return product.immediate_annuity_result[0]?.attributes.immediate_total_overall_score;
      }
      return -1;
    },

    getScoreLabel() {
      if (this.simpleParams.objective === 'savings') {
        return this.$t('products.annuity.as_savingsAnnuityScore');
      }
      else if (this.simpleParams.objective === 'stable_retirement_income') {
        return this.$t('products.annuity.ar_retirementAnnuityScore');
      }
      else if (this.simpleParams.objective === 'growth_retirement_income') {
        return this.$t('products.annuity.ar_retirementAnnuityScore');
      }
      else if (this.simpleParams.objective === 'longevity') {
        return this.$t('products.annuity.al_longevityAnnuityScore');
      }
      else if (this.simpleParams.objective === 'immediate_annuity') {
        return this.$t('products.annuity.ai_immediateAnnuityScore');
      }
      else {
        return '';
      }
    },

    getScoreTooltip() {
      switch (this.simpleParams.objective) {
        case 'savings':
          return this.getAnnuityTooltipContentByKey('tl_savingsAnnuityScore');

        case 'stable_retirement_income':
          return this.getAnnuityTooltipContentByKey('ar_retirementAnnuityScore');

        case 'growth_retirement_income':
          return this.getAnnuityTooltipContentByKey('ar_retirementAnnuityScore');

        case 'longevity':
          return this.getAnnuityTooltipContentByKey('al_longevityAnnuityScore');
          
        case 'immediate_annuity':
          return this.getImmediateAnnuityTooltipContentByKey('ai_immediateAnnuityScore');

      }
    },

    getImmediateAnnuityTooltipContentByKey(mKey) {
      return this.immediateAnnuityTooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getAnnuityTooltipContentByKey(mKey) {
      return this.annuityTooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const link = this.currentLink;
      const categoryName = item.attributes.annuity_plan.data.attributes.plan_type === 'deferred annuity' ? this.$t('products.annuity.as_categoryName') : this.$t('products.annuity.ai_categoryName');
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(categoryName, insurer, planName, { page: this.$route.name.split('__')[0], link: link });
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.annuity_plan.data.attributes.saleable;
      const productWebsite = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },

    unfavourite() {
      this.product = null;
    },
  },
}
